import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;

export class ZIDXAccountCDNPublishSites implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCDNPublishSitesContainer";
    }
    render() {
        // console.log("cdn publish sites");
    }
}